// extracted by mini-css-extract-plugin
export default {"innerWrapper":"mx-z","tooltipWrapper":"nx-z","icon":"ox-z","tooltip":"px-z","content":"qx-z"};